import { render, staticRenderFns } from "./LeadershipCare.vue?vue&type=template&id=65c1198a&"
import script from "./LeadershipCare.vue?vue&type=script&lang=js&"
export * from "./LeadershipCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports